import Footer from "../components/Footer";
import Main from "../components/Main";
import Nav from "../components/Nav";

function Homepage() {
  return (
    <>
      <Nav />
      <Main />
      <Footer />
    </>
  );
}

export default Homepage;
